


















































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateUser from "./create-user.vue";
import EditUser from "./edit-user.vue";
import SeletedCourt from "./SeletedCourt.vue";
import appconst from "@/lib/appconst";
class PageUserRequest extends PageRequest {
  keyword: string;
  isActive: boolean = null; //nullable
  createDate: Date;
  onlyShowVip: boolean = false;
}

@Component({
  components: { CreateUser, EditUser, SeletedCourt },
})
export default class Users extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  //filters
  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];
  seletedList: any = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  openCourtModal: boolean = false;

  get list() {
    return this.$store.state.user.list;
  }
  get loading() {
    return this.$store.state.user.loading;
  }
  create() {
    this.createModalShow = true;
  }
  async handleSelectAll(selection) {
    let selectionList: any = [];
    for (let i = 0; i < selection.length; i++) {
      selectionList.push(selection[i].id);
    }
    this.seletedList = selectionList;
  }
  isActiveChange(val: string) {
    if (val === "Actived") {
      this.pagerequest.isActive = true;
    } else if (val === "NoActive") {
      this.pagerequest.isActive = false;
    } else {
      this.pagerequest.isActive = null;
    }
  }
  /**
   * @description:单行选中发生改变的时候触发
   */
  selectionChange(e) {
    if (e.length > 0) {
      this.seletedList = [];
      for (let it of e) {
        this.seletedList.push(it.id);
      }
    } else {
      this.seletedList = [];
    }
  }
  seedCoupon() {
    this.openCourtModal = true;
  }
  pageChange(page: number) {
    this.$store.commit("user/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("user/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("user/setCurrentPage", 1);
    this.getpage();
  }
  async handCancelAll() {
    this.seletedList = [];
  }
  async exportExcel() {
    try {
      let res = await this.$store.dispatch({
        type: "user/exportExcel",
      });
      if (res && res.data && res.data.result) {
        let url = `${appconst.excelDownloadUrl}${res.data.result}`;
        window.open(url, "_blank");
      }
    } catch (error) {
      console.error("导出 Excel 失败:", error);
    }
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "user/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.user.pageSize;
  }
  get totalCount() {
    return this.$store.state.user.totalCount;
  }
  get currentPage() {
    return this.$store.state.user.currentPage;
  }
  columns = [
    {
      title: "全选",
      width: 50,
      type: "selection",
    },
    {
      title: this.L("UserName"),
      tooltip: true,
      width: 150,
      key: "userName",
    },
    {
      title: this.L("Name"),
      tooltip: true,
      width: 150,
      key: "name",
    },
    {
      title: "手机号",
      tooltip: true,
      key: "phoneNumber",
    },
    {
      title: this.L("IsActive"),
      width: 80,
      render: (h: any, params: any) => {
        return h("span", params.row.isActive ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: "账户余额",
      key: "amount",
      width: 100,
      render: (h: any, params: any) => {
        return h("span", this.L("CurrencyIcon") + params.row.amount.toFixed(2));
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.creationTime
            ? new Date(params.row.creationTime).toLocaleString()
            : "暂无"
        );
      },
    },
    {
      title: this.L("LastLoginTime"),
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastLoginTime
            ? new Date(params.row.lastLoginTime).toLocaleString()
            : "暂无"
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 120,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("user/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteUserConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "user/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    await this.$store.dispatch({
      type: "user/getRoles",
    });
  }
}
